// extracted by mini-css-extract-plugin
module.exports = {"hero":"blog-post-module--hero--TcLt-","blogImage":"blog-post-module--blogImage--2RO7N"};